export enum KategorieEnum {
    DESKTOP = "DESKTOP",
    MOBILGERAETE_APP = "MOBILGERÄTE-APP",
    COMMUNITY = "COMMUNITY",
}
